export const tidyKeyData = (keyDataType: string) => {
    const tidiedKeyData = keyDataType.replaceAll('_', ' ');

    return tidiedKeyData;
};
